import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

//components
import Field from '../../Common/Field/Field'
import Button from '../../Buttons/Button'

//services
import { DevelopmentServices } from '../../../services'
export default class SolidGreige extends Component {
    state = {
        solidGreige : {},
        fabricInfo : {},
        disabled :false
    }

    componentDidMount(){
        if(this.props.scroll){
            var solidGreigeEle = document.getElementById('solidGreigeId')
            solidGreigeEle.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
        }
        this.setState({
            solidGreige : this.props.solidGreige,
            fabricInfo : this.props.fabricInfo,
            disabled : this.props.disabled
        })
    }

    componentWillReceiveProps(nextProps){
        this.setState({
            solidGreige : nextProps.solidGreige,
            fabricInfo : nextProps.fabricInfo,
            disabled : nextProps.disabled
        })
        if(nextProps.forceUpdateCall){
            
        }
    }


    updateValue = (name, value) => {
        this.props.getSolidGreige('solidGreige', name, value)
    }

    createSolid = (e) => {
        e.preventDefault()
        let solidGreige = {...this.props.solidGreige}
         let _id = this.props._id
        solidGreige.actionedBy = null
        let toggle = {...this.props.toggle}
        let data = {
            solidGreige : solidGreige,
            toggle: toggle,
            _id : _id
        }
        DevelopmentServices.createSolid(data).then(response =>{
            if(response.status === 200){
                this.props.getalertMessage('success','GREIGE / DENIM created ')
            }
            response.status === 401 && this.props.unauthorisedFunc()
        })
    }


    render() {

        const { solidGreige  , disabled , fabricInfo  } = this.state

        return (
            <div className="col-md-12 px-5" id="solidGreigeId">
                <h6 className="text-green font-lg font-weight-bold"> GREIGE / DENIM</h6>
                <div className="col-md-12 product-form px-0">
                    
                    <div className="col-md-3 step-one pr-0">
                        <Field
                            isFormGroup={true}
                            inputType='select'
                            inputName='actionedBy'
                            value = {fabricInfo && fabricInfo['GREIGE/DENIM'] && fabricInfo['GREIGE/DENIM'].ASSIGNEDTO && fabricInfo['GREIGE/DENIM'].ASSIGNEDTO.length > 0 && fabricInfo['GREIGE/DENIM'].ASSIGNEDTO[0].value}
                            options={fabricInfo['GREIGE/DENIM'] ? fabricInfo['GREIGE/DENIM'].ASSIGNEDTO : []}
                            label='Assigned To'
                            onChange={this.updateValue}
                            disabled={true}
                        />
                    </div>

                    <div className="col-md-2 step-one pr-0">
                        <Field
                            isFormGroup={true}
                            inputType='select'
                            inputName='typeOfLoom'
                            value = {solidGreige.typeOfLoom}
                            options={fabricInfo && fabricInfo['GREIGE/DENIM'] ? fabricInfo['GREIGE/DENIM'].TYPEOFLOOM : []}
                            label='Type of loom'
                            onChange={this.updateValue}
                            disabled={disabled}
                        />
                    </div>
                    
                    <div className="col-md-2 step-one pr-0">
                        <Field
                            isFormGroup={true}
                            inputType='select'
                            inputName='weave'
                            value={solidGreige.weave}
                            options={fabricInfo['GREIGE/DENIM'] ? fabricInfo['GREIGE/DENIM'].WEAVE : []}
                            label='Weave'
                            onChange={this.updateValue}
                            disabled={disabled}
                        />
                    </div>
                    <div className="col-md-2">
                        <Field
                            isFormGroup={true}
                            inputType='select'
                            inputName='designDescription'
                            value={solidGreige.designDescription}
                            options={fabricInfo.DESIGN}
                            label='Design'
                            onChange={this.updateValue}
                            disabled={disabled}
                        />
                    </div>

                    <div className="col-md-12 profile-btn text-center">
                        {this.state.action != 'view' && <Button
                            buttonName='Save'
                            onClick={this.createSolid}
                        />}
                        <Button
                            buttonName='Cancel'
                            buttonType = 'cancel'
                            history ={this.props.history}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

SolidGreige.propTypes = {

};

SolidGreige.defaultProps = {

}


// WEBPACK FOOTER //
// ./src/components/Fabric/SolidGreige/SolidGreige.js